import './app/quiz';
import './app/slider';
import './app/validation';
import './app/submission';
import './app/cookies-msg';
